import React, {useState} from "react";
import {Button, Card, Col, Modal, Row} from "react-bootstrap";
import {
    GENRES,
    intersperse,
    isLoggedIn,
    isLoggedInWithRole,
    isLoggedInWithRoleAndUserIs,
    sizeToText,
    SLOT_DESCRIPTIONS,
    soundSystemToText
} from "../../common/utils";
import {Link} from "react-router-dom";
import ActsService from "../../services/acts.service";
import Container from "react-bootstrap/Container";
import AuthService from "../../services/auth.service";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const ActItem = ({act}) => {
    let canEdit = isLoggedInWithRoleAndUserIs('performer', act.creator_id);
    let loggedInAdmin = isLoggedInWithRole('admin');

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);

    const deleteAct = () => {
        ActsService.deleteAct(act.id).then(
            response => {
                console.log("act:" + act.id + " deleted");
                // todo: pass redirect url since could be coming from "/myacts"
                window.location.assign("/acts");
            },
            error => {
                console.log(error);
            });
    }


    let displaySlots = "";
    for (let i = 0; i < act.preferred_slots.length; i++) {
        displaySlots += "<span>" + act.preferred_slots[i] + ": " + SLOT_DESCRIPTIONS[act.preferred_slots[i]] + "</span><br/>";
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Title>
                        <span>&#127908;</span>&nbsp;
                        <span className="fs-4 text"><strong>{act.name}</strong></span>
                        {canEdit &&
                            <>
                                &nbsp;&nbsp;
                                <span>
                                    <Button size="sm" variant="outline-primary" href={`/acts/${act.id}/edit`}
                                            disabled={!editsAllowed}>
                                        Edit
                                    </Button>&nbsp;&nbsp;
                                    <Button size="sm" variant="outline-danger" onClick={handleShowDeleteModal}
                                            disabled={!editsAllowed}>
                                        Delete
                                    </Button>
                                </span>
                            </>
                        }
                        {loggedIn &&
                            <>
                                &nbsp;&nbsp;
                                <Button size="sm" variant="outline-info" href={`/acts/${act.id}/contact`}
                                        disabled={!editsAllowed}>
                                    Contact
                                </Button>
                            </>
                        }
                    </Card.Title>

                    <Container fluid>
                        {loggedInAdmin &&
                            <>
                                <Row><Col><strong>Creator</strong></Col></Row>
                                <Row className="mb-3">
                                    <Col>
                                        {act.creator.name} / {act.creator.email} / {intersperse(act.creator.roles, ", ")}
                                    </Col>
                                </Row>
                            </>
                        }
                        <Row><Col><strong>Description</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: act.bio}} className="pf-quill-render"></span>
                            </Col>
                        </Row>

                        <Row><Col><strong>Size</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: sizeToText(act.size)}}/>
                            </Col>
                        </Row>

                        <Row><Col><strong>Genre</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span
                                    style={{textTransform: 'capitalize'}}>{GENRES.find(genre => genre.value === act.type)?.name}</span>
                            </Col>
                        </Row>

                        <Row><Col><strong>Preferred slots</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {act.preferred_slots.length > 0 &&
                                    <span dangerouslySetInnerHTML={{__html: displaySlots}}></span>
                                }
                            </Col>
                        </Row>

                        <Row><Col><strong>Preferred venue</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {act.venue_pref &&
                                    <span>{act.venue_pref}</span>
                                }
                                {!act.venue_pref &&
                                    <span>None</span>
                                }
                            </Col>
                        </Row>

                        <Row><Col><strong>Sound system</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: soundSystemToText(act.sound_system)}}/>
                            </Col>
                        </Row>

                        <Row><Col><strong>Rain date</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {act.rain_date_available &&
                                    <span>Available</span>
                                }
                                {!act.rain_date_available &&
                                    <span>Unavailable</span>
                                }
                            </Col>
                        </Row>

                        <Row><Col><strong>Status</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {act.scheduled_venue_slots.length > 0 &&
                                    <>
                                        Scheduled to play:<br/>
                                        {Array.from({length: act.scheduled_venue_slots.length}).map((_, index) => (
                                            <span key={index}>
                                                {act.scheduled_venue_slots[index].slot_def + ": " + SLOT_DESCRIPTIONS[act.scheduled_venue_slots[index].slot_def]}, at <Link
                                                to={`/venues/${act.scheduled_venue_slots[index].venue.id}`}
                                                reloadDocument="true">
                                                    {act.scheduled_venue_slots[index].venue.address}
                                                </Link>
                                                <br/>
                                            </span>
                                        ))}
                                    </>
                                }
                                {act.scheduled_venue_slots.length === 0 &&
                                    <>Looking for a host</>
                                }
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>

            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Act?</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete "{act.name}"?</Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteAct}>
                        Delete Act
                    </Button>
                    <Button variant="outline-secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ActItem;
